import React, { useState } from 'react';

import Heading from '@tds/core-heading';
import DimpleDivider from '@tds/core-dimple-divider';

import FullyManaged from './fullyManaged/index';
import CopperInternet from './copperInternet';

export default function ProductCatalogueDashboard() {
  const [tabSelected, setTabSelected] = useState('FULLY_MANAGED');
  return (
    <div className="container 85%" style={{ padding: '2rem' }}>
      <Heading level="h2">Product Catalogue Dashboard</Heading>
      <div
        style={{
          marginTop: '2rem',
          borderBottom: '1px solid #e4e4e4',
          padding: '0 2rem'
        }}
      >
        <ul
          style={{
            display: 'flex',
            gap: '2rem'
          }}
        >
          <li
            style={{
              padding: '1rem 2rem',
              borderRadius: '6px 6px 0 0',
              background:
                tabSelected === 'FULLY_MANAGED' ? '#4b286d' : '#ffffff',
              border:
                tabSelected === 'FULLY_MANAGED'
                  ? '2px solid #4b286d'
                  : '1px solid #e4e4e4',
              borderBottom: 0,
              color: tabSelected === 'FULLY_MANAGED' ? '#ffffff' : '#454545',
              fontWeight: tabSelected === 'FULLY_MANAGED' ? '800' : '500',
              cursor: 'pointer'
            }}
            onClick={() => setTabSelected('FULLY_MANAGED')}
          >
            Fully Managed
          </li>
          <li
            style={{
              padding: '1rem 2rem',
              borderRadius: '6px 6px 0 0',
              background:
                tabSelected === 'COPPER_INTERNET' ? '#4b286d' : '#ffffff',
              border:
                tabSelected === 'COPPER_INTERNET'
                  ? '2px solid #4b286d'
                  : '1px solid #e4e4e4',
              borderBottom: 0,
              color: tabSelected === 'COPPER_INTERNET' ? '#ffffff' : '#454545',
              fontWeight: tabSelected === 'COPPER_INTERNET' ? '800' : '500',
              cursor: 'pointer'
            }}
            onClick={() => setTabSelected('COPPER_INTERNET')}
          >
            Copper Internet
          </li>
        </ul>
      </div>
      <DimpleDivider />
      {tabSelected === 'FULLY_MANAGED' ? <FullyManaged /> : <CopperInternet />}
    </div>
  );
}
